import React, { useEffect, useState, useMemo, useRef } from 'react';
import { useParams, useHistory } from 'react-router-dom';
import { observer } from 'mobx-react-lite';
import { useTranslation } from 'react-i18next';
import { useStore } from '@/models';
import SecondStep from './components/secondStep';
import FirstStep from './components/firstStep';
import LastStep from './components/lastStep';
import cs from './index.module.scss';
import cx from 'classnames';
import '@/lib/gt';
import backIcon from '@/assets/common/backIcon.png';

const Login: React.FC = () => {
  const { t } = useTranslation();
  const { account, ui } = useStore();
  const {
    loginLastStepVisible,
    loginFisrtStepVisible,
    loginSeconStepVisible,
    setLoginFisrtStepVisible,
    setLoginSeconStepVisible,
    setLoginLastStepVisible,
  } = account;
  const back = () => {
    setLoginFisrtStepVisible(true);
    setLoginLastStepVisible(false);
  };
  const { push } = useHistory();
  useEffect(() => {
    setLoginFisrtStepVisible(true);
    setLoginSeconStepVisible(false);
    setLoginLastStepVisible(false);
  }, []);

  useEffect(() => {
    const scriptId = 'dotlottie-player-script';
    if (document.getElementById(scriptId)) {
      return;
    }
    const script = document.createElement('script');
    script.id = scriptId;
    script.src = 'https://unpkg.com/@dotlottie/player-component@2.7.12/dist/dotlottie-player.mjs';
    script.type = 'module';
    document.body.appendChild(script);
  }, []);
  return (
    <div className={cs.container} onClick={() => {
      ui.hideLoginModal();
    }}>
      <div
        className={cs.contentBox}
        onClick={e => {
          e.stopPropagation();
        }}
      >
        <div className={cs.title}>
          {loginFisrtStepVisible ? <span>{t('signIn.loginAccount3')}</span> :
            <div className={cs.backIcon}>
              <img width={22} height={22} src={backIcon} alt="" onClick={back} />
            </div>
          }

          <div
            className={cx(cs.toReg, 'pointer')}
            onClick={() => {
              // push('/register');
              ui.hideLoginModal();
              ui.showRegisterModal();
            }}
          >
            <span className={cs.noAccount}>{t('signIn.noAccount')}</span>
            <span className={cx('pointer', 'text-primary')}>{t('btn.signUpNow')}</span>
          </div>
        </div>
        <div className={cs.contentBox2}>
          <div className={cs.left}>
            <dotlottie-player
              src="/lottiejson/home_login_Lottie.json"
              background="transparent"
              speed="1"
              loop
              autoplay
              className={cs.loginLottie}
            />
          </div>
          <>
            {loginFisrtStepVisible && <FirstStep />}

            {/* {loginSeconStepVisible && <SecondStep />} */}
            {loginLastStepVisible && <LastStep />}
          </>
        </div>


      </div>
    </div>
  );
};

export default observer(Login);
